import React from "react";
import { Helmet } from "react-helmet-async";

/**
 * Page-level SEO helper. Sets title, meta description, canonical URL,
 * Open Graph and Twitter Card tags per-page.
 */
const SEO = ({
    title,
    description,
    canonicalPath = "",
    image = "/images/wp/2026/04/Ana-Cristina-Advocacia-Portugal.jpg",
    type = "website",
    articleData = null,
}) => {
    const base = "https://acd-advogados.net";
    const url = `${base}${canonicalPath}`;
    const fullTitle = title
        ? `${title} | ACD Advogados`
        : "ACD Advogados | Ana Cristina Domingues - Assessoria Jurídica de Excelência";
    const desc =
        description ||
        "Assessoria jurídica de excelência desde 1995 em Lisboa e Açores. Direito Penal, Civil, Trabalho, Comercial, Fiscal, Imigração e Nacionalidade.";

    return (
        <Helmet>
            <title>{fullTitle}</title>
            <meta name="description" content={desc} />
            <link rel="canonical" href={url} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={desc} />
            <meta property="og:url" content={url} />
            <meta property="og:type" content={type} />
            <meta property="og:image" content={image} />
            <meta property="og:locale" content="pt_PT" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={desc} />
            <meta name="twitter:image" content={image} />
            {articleData && (
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Article",
                        headline: articleData.title,
                        image: [articleData.image],
                        datePublished: articleData.date_iso,
                        dateModified: articleData.date_iso,
                        author: {
                            "@type": "Person",
                            name: articleData.author,
                        },
                        publisher: {
                            "@type": "Organization",
                            name: "ACD Advogados",
                            logo: {
                                "@type": "ImageObject",
                                url: "/images/wp/2026/04/logo-new_2021.png",
                            },
                        },
                        articleSection: articleData.category,
                        description: articleData.excerpt,
                        mainEntityOfPage: {
                            "@type": "WebPage",
                            "@id": url,
                        },
                    })}
                </script>
            )}
        </Helmet>
    );
};

export default SEO;
